/* Copyright (c) 2018-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// Components
import { OAuthService } from './services/o-auth.service';
import { StarfleetConfig } from './starfleet-config';
import { StarfleetServiceProvider } from './starfleet.service.provider';

const MATERIAL_DESIGN_MODULES = [MatProgressSpinnerModule];

@NgModule({
    exports: [...MATERIAL_DESIGN_MODULES],
    imports: [CommonModule, ...MATERIAL_DESIGN_MODULES],
    providers: [StarfleetServiceProvider, provideHttpClient(withInterceptorsFromDi())]
})
export class StarfleetModule {
    static configure(config: StarfleetConfig): ModuleWithProviders<StarfleetModule> {
        return {
            ngModule: StarfleetModule,
            providers: [
                {
                    provide: StarfleetConfig,
                    useValue: config
                },
                StarfleetServiceProvider,
                OAuthService
            ]
        };
    }
}
